var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgW1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.334 107.24V188.191C153.336 189.787 152.8 191.337 151.811 192.588C150.823 193.839 149.442 194.717 147.893 195.08L78.2962 211.555C77.2302 211.809 76.1197 211.809 75.0537 211.555L5.45702 195.08C3.90623 194.718 2.52301 193.84 1.53225 192.589C0.5415 191.339 0.00147593 189.788 0 188.191V107.24C0.000398441 106.288 0.192563 105.346 0.564951 104.47C0.937339 103.594 1.48227 102.803 2.16699 102.145H151.183C151.871 102.804 152.418 103.598 152.791 104.476C153.163 105.355 153.353 106.301 153.35 107.256L153.334 107.24Z",
    fill: "url(#paint0_linear_47_2189)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.666 125.383V117.859H84.5747L76.666 125.383Z",
    fill: "url(#paint1_linear_47_2189)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.167 102.145H108.08V204.571L147.893 195.143C149.442 194.781 150.823 193.902 151.811 192.651C152.799 191.401 153.336 189.851 153.334 188.254V107.303C153.337 106.348 153.147 105.403 152.774 104.524C152.402 103.645 151.855 102.852 151.167 102.192V102.145Z",
    fill: "url(#paint2_linear_47_2189)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6666 102.145V211.809C76.1339 211.806 75.6033 211.742 75.0849 211.619L5.48826 195.143C3.93746 194.781 2.55424 193.904 1.56349 192.653C0.572738 191.402 0.0327259 189.852 0.03125 188.254V107.303C0.0316484 106.351 0.223813 105.409 0.596201 104.534C0.968589 103.658 1.51351 102.867 2.19823 102.208L76.6666 102.145Z",
    fill: "url(#paint3_linear_47_2189)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6666 102.145V211.809C76.1339 211.806 75.6033 211.742 75.0849 211.619L5.48826 195.143C3.93746 194.781 2.55424 193.904 1.56349 192.653C0.572738 191.402 0.0327259 189.852 0.03125 188.254V107.303C0.0316484 106.351 0.223813 105.409 0.596201 104.534C0.968589 103.658 1.51351 102.867 2.19823 102.208L76.6666 102.145Z",
    fill: "url(#paint4_linear_47_2189)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6667 161.857V211.809C76.1339 211.806 75.6033 211.742 75.0849 211.618L5.48826 195.143C3.93747 194.781 2.55424 193.903 1.56349 192.652C0.572738 191.402 0.0327259 189.852 0.03125 188.254V144.651L68.8845 160.953C71.4513 161.554 74.0783 161.857 76.7141 161.857H76.6667Z",
    fill: "url(#paint5_linear_47_2189)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.666 161.857V211.809C77.1988 211.806 77.7294 211.742 78.2478 211.618L147.844 195.143C149.394 194.78 150.775 193.902 151.763 192.651C152.751 191.4 153.288 189.85 153.286 188.254V144.651L84.4482 160.953C81.8968 161.55 79.2859 161.853 76.666 161.857Z",
    fill: "url(#paint6_linear_47_2189)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.164 102.146L80.7452 118.749C78.0614 119.384 75.2672 119.384 72.5834 118.749L2.14844 102.082C3.06153 101.2 4.1912 100.575 5.42264 100.273L75.0193 83.7968C76.0854 83.543 77.1958 83.543 78.2618 83.7968L104.297 90.0189V93.1935H117.568L147.906 100.368C149.139 100.667 150.269 101.292 151.18 102.177L151.164 102.146Z",
    fill: "url(#paint7_linear_47_2189)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.299 90.0194V93.194L34.2596 109.765L2.16602 102.178C3.07911 101.295 4.20878 100.671 5.44022 100.368L75.0369 83.8925C76.1029 83.6387 77.2134 83.6387 78.2794 83.8925L104.299 90.0194Z",
    fill: "url(#paint8_linear_47_2189)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M104.3 90.0176L29.0882 107.811C28.6699 107.914 28.2979 108.154 28.0313 108.493C27.7647 108.833 27.619 109.252 27.6172 109.684V133.35C27.6177 133.6 27.7023 133.843 27.8573 134.039C28.0123 134.235 28.2287 134.372 28.4713 134.43L39.5435 137.049C39.7058 137.087 39.8747 137.088 40.0374 137.051C40.2001 137.015 40.3526 136.942 40.4833 136.838C40.6141 136.735 40.7199 136.603 40.7927 136.452C40.8655 136.302 40.9035 136.137 40.9038 135.969V112.684C40.907 112.291 41.0411 111.91 41.2848 111.602C41.5284 111.295 41.8675 111.078 42.2483 110.985L117.587 93.1604L104.3 90.0176Z",
    fill: "url(#paint9_linear_47_2189)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3793 106.05L42.2156 111.049C41.9134 111.126 41.6358 111.279 41.4089 111.494L28.1855 108.319C28.4324 108.08 28.738 107.91 29.0713 107.827L50.0927 102.875L63.3793 106.05Z",
    fill: "url(#paint10_linear_47_2189)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.185 108.304L41.4084 111.478C41.2394 111.64 41.1047 111.835 41.0123 112.05C40.9199 112.266 40.8717 112.498 40.8706 112.732V136.018C40.8703 136.185 40.8323 136.35 40.7595 136.5C40.6867 136.651 40.5809 136.783 40.4501 136.887C40.3194 136.991 40.1669 137.063 40.0042 137.1C39.8414 137.136 39.6726 137.135 39.5103 137.097L28.4381 134.478C28.1955 134.421 27.9791 134.283 27.8241 134.087C27.6691 133.891 27.5845 133.649 27.584 133.399V109.685C27.5853 109.426 27.6393 109.169 27.7426 108.932C27.846 108.695 27.9965 108.481 28.185 108.304Z",
    fill: "url(#paint11_linear_47_2189)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6016 121.923V133.319C27.6021 133.57 27.6867 133.812 27.8417 134.008C27.9967 134.204 28.213 134.342 28.4557 134.399L39.5279 137.018C39.6902 137.056 39.859 137.057 40.0218 137.021C40.1845 136.984 40.3369 136.911 40.4677 136.808C40.5985 136.704 40.7042 136.572 40.777 136.421C40.8499 136.271 40.8878 136.106 40.8882 135.938V121.923H27.6016Z",
    fill: "url(#paint12_linear_47_2189)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.383 184.986L38.8948 192.208C39.1327 192.269 39.3817 192.275 39.622 192.223C39.8623 192.172 40.0873 192.065 40.2791 191.91C40.471 191.756 40.6245 191.56 40.7274 191.336C40.8303 191.112 40.8798 190.867 40.872 190.62V173.827C40.8809 173.46 40.7629 173.101 40.5379 172.812C40.313 172.523 39.995 172.32 39.6382 172.24L9.12642 165.018C8.88852 164.956 8.63955 164.951 8.39925 165.002C8.15896 165.054 7.93395 165.161 7.74207 165.315C7.55019 165.469 7.3967 165.666 7.2938 165.89C7.1909 166.114 7.14141 166.358 7.14924 166.605V183.414C7.14031 183.781 7.25835 184.14 7.4833 184.429C7.70825 184.719 8.02619 184.921 8.383 185.001V184.986Z",
    fill: "url(#paint13_linear_47_2189)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14891 171.366V183.414C7.13997 183.781 7.25802 184.139 7.48297 184.429C7.70792 184.718 8.02586 184.92 8.38267 185.001L38.8945 192.223C39.1324 192.285 39.3813 192.29 39.6216 192.239C39.8619 192.187 40.0869 192.08 40.2788 191.926C40.4707 191.772 40.6242 191.575 40.7271 191.351C40.83 191.127 40.8795 190.882 40.8717 190.636V179.35L7.14891 171.366Z",
    fill: "url(#paint14_linear_47_2189)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6378 172.255L24.1367 168.589V188.715L38.8944 192.207C39.1323 192.269 39.3812 192.274 39.6215 192.223C39.8618 192.171 40.0868 192.064 40.2787 191.91C40.4706 191.756 40.6241 191.559 40.727 191.335C40.8299 191.111 40.8794 190.866 40.8716 190.62V173.827C40.8768 173.462 40.7571 173.107 40.5324 172.821C40.3078 172.535 39.9919 172.335 39.6378 172.255Z",
    fill: "url(#paint15_linear_47_2189)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7852 188.127C88.7837 188.352 88.8331 188.574 88.9298 188.776C89.0266 188.978 89.168 189.156 89.3434 189.295C89.5187 189.434 89.7235 189.532 89.9419 189.58C90.1604 189.628 90.3869 189.625 90.6042 189.572L112.495 184.397C112.825 184.322 113.118 184.136 113.328 183.87C113.538 183.605 113.652 183.276 113.65 182.937C113.649 182.712 113.598 182.49 113.499 182.288C113.4 182.085 113.258 181.908 113.081 181.769C112.905 181.63 112.699 181.533 112.48 181.485C112.261 181.437 112.033 181.44 111.815 181.493L89.924 186.683C89.5992 186.759 89.3095 186.943 89.1026 187.205C88.8957 187.468 88.7838 187.793 88.7852 188.127Z",
    fill: "url(#paint16_linear_47_2189)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6042 195.414L101.518 192.843C101.844 192.764 102.134 192.577 102.341 192.312C102.548 192.047 102.659 191.719 102.657 191.383C102.659 191.158 102.609 190.937 102.512 190.734C102.416 190.532 102.274 190.354 102.099 190.215C101.924 190.076 101.719 189.978 101.5 189.931C101.282 189.883 101.055 189.885 100.838 189.938L89.924 192.526C89.6005 192.604 89.3125 192.789 89.106 193.05C88.8995 193.312 88.7866 193.636 88.7852 193.97C88.7837 194.194 88.8331 194.416 88.9298 194.619C89.0266 194.821 89.168 194.999 89.3434 195.138C89.5187 195.277 89.7235 195.374 89.9419 195.422C90.1604 195.47 90.3869 195.468 90.6042 195.414Z",
    fill: "url(#paint17_linear_47_2189)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M230 125.382V206.333C230.002 207.93 229.465 209.48 228.477 210.731C227.489 211.982 226.108 212.86 224.559 213.222L154.962 229.698C153.896 229.952 152.786 229.952 151.72 229.698L82.1229 213.222C80.5736 212.86 79.1924 211.982 78.2043 210.731C77.2162 209.48 76.6795 207.93 76.6817 206.333V125.382C76.6791 124.431 76.8684 123.49 77.2381 122.614C77.6078 121.738 78.1502 120.947 78.8328 120.287H227.865C228.543 120.949 229.081 121.742 229.448 122.617C229.815 123.492 230.003 124.433 230 125.382Z",
    fill: "url(#paint18_linear_47_2189)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.851 120.335H184.748V222.714L224.513 213.286C226.062 212.924 227.443 212.045 228.432 210.795C229.42 209.544 229.956 207.994 229.954 206.397V125.446C229.957 124.493 229.768 123.549 229.398 122.67C229.029 121.792 228.486 120.998 227.803 120.335H227.851Z",
    fill: "url(#paint19_linear_47_2189)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.334 120.335V230C152.802 229.997 152.271 229.933 151.753 229.81L82.1561 213.334C80.6068 212.971 79.2256 212.093 78.2375 210.842C77.2494 209.591 76.7127 208.041 76.7149 206.445V125.494C76.7123 124.543 76.9016 123.601 77.2713 122.726C77.641 121.85 78.1835 121.058 78.866 120.399L153.334 120.335Z",
    fill: "url(#paint20_linear_47_2189)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.334 120.335V230C152.802 229.997 152.271 229.933 151.753 229.81L82.1561 213.334C80.6068 212.971 79.2256 212.093 78.2375 210.842C77.2494 209.591 76.7127 208.041 76.7149 206.445V125.494C76.7123 124.543 76.9016 123.601 77.2713 122.726C77.641 121.85 78.1835 121.058 78.866 120.399L153.334 120.335Z",
    fill: "url(#paint21_linear_47_2189)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.334 180.001V229.953C152.802 229.95 152.271 229.886 151.753 229.762L82.156 213.286C80.6068 212.924 79.2256 212.046 78.2375 210.795C77.2494 209.544 76.7127 207.994 76.7149 206.398V162.795L145.505 179.065C148.072 179.666 150.699 179.969 153.334 179.969V180.001Z",
    fill: "url(#paint22_linear_47_2189)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.332 180.001V229.953C153.865 229.948 154.395 229.885 154.914 229.762L224.51 213.286C226.06 212.924 227.441 212.046 228.429 210.795C229.417 209.544 229.954 207.994 229.952 206.398V162.795L161.241 179.065C158.674 179.666 156.047 179.969 153.411 179.969L153.332 180.001Z",
    fill: "url(#paint23_linear_47_2189)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.85 120.334L157.415 137.001C154.731 137.636 151.937 137.636 149.253 137.001L78.834 120.334C79.7448 119.448 80.8754 118.824 82.1082 118.525L151.705 102.049C152.771 101.795 153.881 101.795 154.947 102.049L180.935 108.207V111.382H194.206L224.512 118.477C225.771 118.783 226.925 119.424 227.85 120.334Z",
    fill: "url(#paint24_linear_47_2189)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M227.85 120.334L157.415 137.001C154.731 137.636 151.937 137.636 149.253 137.001L78.834 120.334C79.7448 119.448 80.8754 118.824 82.1082 118.525L151.705 102.049C152.771 101.795 153.881 101.795 154.947 102.049L180.935 108.207V111.382H194.206L224.512 118.477C225.771 118.783 226.925 119.424 227.85 120.334Z",
    fill: "url(#paint25_linear_47_2189)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M180.951 108.16V111.334L110.912 127.905L78.834 120.334C79.7425 119.445 80.8739 118.82 82.1082 118.525L151.705 102.049C152.771 101.795 153.881 101.795 154.947 102.049L180.951 108.16Z",
    fill: "url(#paint26_linear_47_2189)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.95 108.161L105.739 125.955C105.32 126.057 104.948 126.298 104.682 126.637C104.415 126.976 104.269 127.396 104.268 127.828V151.494C104.268 151.744 104.353 151.987 104.508 152.183C104.663 152.379 104.879 152.516 105.122 152.573L116.194 155.192C116.356 155.231 116.525 155.232 116.688 155.195C116.851 155.159 117.003 155.086 117.134 154.982C117.265 154.878 117.37 154.746 117.443 154.596C117.516 154.445 117.554 154.28 117.554 154.113V130.828C117.555 130.434 117.688 130.052 117.932 129.744C118.176 129.435 118.517 129.219 118.899 129.129L194.221 111.304L180.95 108.161Z",
    fill: "url(#paint27_linear_47_2189)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.951 108.161L105.739 125.955C105.405 126.034 105.098 126.205 104.854 126.447L118.077 129.621C118.306 129.41 118.583 129.258 118.884 129.177L194.222 111.352L180.951 108.161Z",
    fill: "url(#paint28_linear_47_2189)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M140.047 124.129L118.899 129.129C118.597 129.206 118.32 129.359 118.093 129.573L104.854 126.399C105.105 126.166 105.409 125.997 105.739 125.907L126.761 120.938L140.047 124.129Z",
    fill: "url(#paint29_linear_47_2189)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M104.853 126.446L118.076 129.621C117.746 129.955 117.559 130.405 117.554 130.875V154.16C117.554 154.327 117.516 154.492 117.443 154.643C117.37 154.794 117.265 154.926 117.134 155.029C117.003 155.133 116.851 155.206 116.688 155.242C116.525 155.279 116.356 155.278 116.194 155.239L105.122 152.62C104.879 152.563 104.663 152.426 104.508 152.23C104.353 152.034 104.268 151.791 104.268 151.541V127.827C104.267 127.569 104.318 127.314 104.419 127.076C104.52 126.839 104.667 126.625 104.853 126.446Z",
    fill: "url(#paint30_linear_47_2189)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.299 140.097V151.493C104.299 151.744 104.384 151.986 104.539 152.182C104.694 152.378 104.91 152.516 105.153 152.573L116.225 155.192C116.387 155.23 116.556 155.231 116.719 155.195C116.882 155.158 117.034 155.085 117.165 154.982C117.296 154.878 117.402 154.746 117.474 154.595C117.547 154.445 117.585 154.28 117.585 154.112V140.097H104.299Z",
    fill: "url(#paint31_linear_47_2189)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0648 203.128L115.577 210.35C115.815 210.412 116.064 210.417 116.304 210.366C116.544 210.314 116.769 210.207 116.961 210.053C117.153 209.899 117.306 209.702 117.409 209.478C117.512 209.254 117.562 209.009 117.554 208.763V191.97C117.562 191.6 117.442 191.24 117.214 190.95C116.986 190.661 116.664 190.46 116.304 190.382L85.7924 183.16C85.5545 183.098 85.3056 183.093 85.0653 183.145C84.825 183.196 84.6 183.303 84.4081 183.457C84.2162 183.611 84.0627 183.808 83.9598 184.032C83.8569 184.256 83.8074 184.501 83.8153 184.747V201.557C83.8071 201.926 83.9274 202.286 84.1554 202.576C84.3835 202.866 84.7051 203.066 85.0648 203.144V203.128Z",
    fill: "url(#paint32_linear_47_2189)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8148 189.509V201.556C83.8067 201.925 83.927 202.286 84.155 202.575C84.3831 202.865 84.7047 203.066 85.0644 203.143L115.576 210.366C115.814 210.427 116.063 210.433 116.303 210.381C116.544 210.329 116.769 210.222 116.961 210.068C117.152 209.914 117.306 209.718 117.409 209.494C117.512 209.27 117.561 209.025 117.553 208.778V197.493L83.8148 189.509Z",
    fill: "url(#paint33_linear_47_2189)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.304 190.398L100.818 186.731V206.858L115.576 210.35C115.814 210.412 116.063 210.417 116.303 210.366C116.543 210.314 116.768 210.207 116.96 210.053C117.152 209.899 117.306 209.702 117.409 209.478C117.512 209.254 117.561 209.009 117.553 208.763V191.969C117.561 191.6 117.441 191.24 117.213 190.95C116.985 190.66 116.663 190.46 116.304 190.382V190.398Z",
    fill: "url(#paint34_linear_47_2189)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.449 206.271C165.451 206.494 165.502 206.714 165.6 206.915C165.697 207.116 165.839 207.292 166.013 207.431C166.188 207.569 166.391 207.667 166.609 207.716C166.826 207.765 167.051 207.765 167.268 207.715L189.175 202.541C189.502 202.462 189.792 202.275 189.998 202.01C190.205 201.744 190.316 201.417 190.314 201.08C190.316 200.856 190.266 200.634 190.17 200.432C190.073 200.229 189.931 200.052 189.756 199.913C189.581 199.773 189.376 199.676 189.157 199.628C188.939 199.58 188.712 199.583 188.495 199.636L166.588 204.826C166.263 204.902 165.974 205.086 165.767 205.348C165.56 205.611 165.448 205.936 165.449 206.271Z",
    fill: "url(#paint35_linear_47_2189)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M167.268 213.556L178.182 210.984C178.511 210.909 178.805 210.723 179.015 210.457C179.225 210.192 179.338 209.863 179.337 209.524C179.336 209.299 179.284 209.077 179.186 208.875C179.087 208.672 178.944 208.495 178.768 208.356C178.591 208.217 178.386 208.12 178.167 208.072C177.947 208.024 177.72 208.027 177.502 208.08L166.588 210.667C166.265 210.745 165.977 210.93 165.77 211.192C165.564 211.453 165.451 211.777 165.449 212.111C165.448 212.336 165.497 212.557 165.594 212.76C165.691 212.962 165.832 213.14 166.007 213.279C166.183 213.418 166.388 213.516 166.606 213.563C166.824 213.611 167.051 213.609 167.268 213.556Z",
    fill: "url(#paint36_linear_47_2189)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M189.428 23.511V104.462C189.427 106.058 188.889 107.606 187.902 108.857C186.914 110.107 185.534 110.986 183.986 111.351L114.39 127.843C113.322 128.081 112.215 128.081 111.147 127.843L41.5506 111.351C40.0027 110.986 38.6231 110.107 37.6354 108.857C36.6478 107.606 36.11 106.058 36.1094 104.462V23.511C36.1122 22.5609 36.3039 21.6208 36.6733 20.7459C37.0427 19.871 37.5823 19.0789 38.2605 18.4159H187.292C187.971 19.0775 188.51 19.8697 188.877 20.7452C189.244 21.6206 189.431 22.5613 189.428 23.511Z",
    fill: "url(#paint37_linear_47_2189)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M187.262 18.4635H144.176V120.89L183.988 111.462C185.536 111.097 186.916 110.218 187.903 108.968C188.891 107.717 189.429 106.169 189.429 104.573V23.511C189.429 22.5591 189.237 21.617 188.864 20.7414C188.492 19.8658 187.947 19.0748 187.262 18.4159V18.4635Z",
    fill: "url(#paint38_linear_47_2189)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112.747 18.4635V128.128C112.214 128.131 111.684 128.072 111.165 127.954L41.5681 111.462C40.0203 111.097 38.6407 110.218 37.653 108.968C36.6653 107.717 36.1276 106.169 36.127 104.573V23.511C36.1298 22.5609 36.3215 21.6208 36.6909 20.7459C37.0602 19.871 37.5999 19.0789 38.2781 18.4159L112.747 18.4635Z",
    fill: "url(#paint39_linear_47_2189)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.747 78.1936V128.129C112.214 128.132 111.684 128.073 111.165 127.955L41.5681 111.463C40.0203 111.098 38.6407 110.219 37.653 108.969C36.6653 107.718 36.1276 106.17 36.127 104.574V60.9717L104.98 77.273C107.541 77.8799 110.163 78.1889 112.794 78.1936H112.747Z",
    fill: "url(#paint40_linear_47_2189)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.747 78.1936V128.129C113.279 128.131 113.81 128.073 114.329 127.955L183.925 111.463C185.473 111.098 186.853 110.219 187.84 108.969C188.828 107.718 189.366 106.17 189.366 104.574V60.9717L120.513 77.273C117.947 77.8791 115.32 78.188 112.684 78.1936H112.747Z",
    fill: "url(#paint41_linear_47_2189)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M187.26 18.4638L116.825 35.1302C114.143 35.7796 111.345 35.7796 108.663 35.1302L38.244 18.4638C39.1557 17.5826 40.2865 16.9632 41.5182 16.6702L111.115 0.178402C112.183 -0.0594673 113.29 -0.0594673 114.357 0.178402L140.345 6.33703V9.51158H153.632L183.97 16.7019C185.202 16.9949 186.332 17.6143 187.244 18.4956L187.26 18.4638Z",
    fill: "url(#paint42_linear_47_2189)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.361 6.33703V9.51158L70.3218 26.0669L38.244 18.4638C39.1557 17.5826 40.2865 16.9632 41.5182 16.6702L111.115 0.178402C112.183 -0.0594673 113.29 -0.0594673 114.357 0.178402L140.361 6.33703Z",
    fill: "url(#paint43_linear_47_2189)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M140.362 6.33789L65.1506 24.1471C64.7338 24.2445 64.3625 24.4816 64.0979 24.8192C63.8334 25.1568 63.6914 25.5748 63.6954 26.0042V49.6705C63.6959 49.9206 63.7805 50.1633 63.9355 50.3591C64.0905 50.555 64.3069 50.6927 64.5495 50.7499L75.6217 53.3689C75.784 53.4071 75.9528 53.4081 76.1156 53.3717C76.2783 53.3353 76.4308 53.2625 76.5616 53.1587C76.6923 53.055 76.7981 52.9229 76.8709 52.7724C76.9437 52.6219 76.9817 52.4568 76.982 52.2895V29.0201C76.9796 28.6256 77.1116 28.2421 77.3561 27.9332C77.6006 27.6243 77.943 27.4085 78.3265 27.3217L153.649 9.4807L140.362 6.33789Z",
    fill: "url(#paint44_linear_47_2189)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5531 22.3047L78.3894 27.3205C78.0859 27.3849 77.8065 27.5334 77.5827 27.749L64.3594 24.5745C64.6035 24.3431 64.9033 24.179 65.2293 24.0983L86.2665 19.1143L99.5531 22.3047Z",
    fill: "url(#paint45_linear_47_2189)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2807 24.623L77.5041 27.7976C77.3354 27.9631 77.201 28.1606 77.1087 28.3785C77.0164 28.5965 76.968 28.8306 76.9663 29.0674V52.3369C76.9691 52.5052 76.9331 52.6719 76.8612 52.824C76.7894 52.9761 76.6836 53.1095 76.552 53.2139C76.4204 53.3183 76.2666 53.3909 76.1026 53.426C75.9385 53.4611 75.7686 53.4577 75.606 53.4162L64.5338 50.7972C64.2912 50.7401 64.0748 50.6024 63.9198 50.4065C63.7648 50.2106 63.6802 49.968 63.6797 49.7179V26.004C63.6913 25.4823 63.9072 24.9861 64.2807 24.623Z",
    fill: "url(#paint46_linear_47_2189)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6797 38.2734V49.6701C63.6802 49.9202 63.7648 50.1628 63.9198 50.3587C64.0748 50.5546 64.2912 50.6923 64.5338 50.7494L75.606 53.3684C75.7683 53.4067 75.9371 53.4076 76.0999 53.3713C76.2626 53.3349 76.415 53.2621 76.5458 53.1583C76.6766 53.0545 76.7824 52.9225 76.8552 52.772C76.928 52.6214 76.966 52.4564 76.9663 52.2891V38.2734H63.6797Z",
    fill: "url(#paint47_linear_47_2189)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4771 101.288L74.9889 108.526C75.2268 108.587 75.4757 108.593 75.716 108.541C75.9563 108.49 76.1813 108.382 76.3732 108.228C76.5651 108.074 76.7186 107.878 76.8215 107.654C76.9244 107.43 76.9739 107.185 76.9661 106.938V90.1767C76.975 89.8098 76.857 89.4511 76.632 89.1617C76.4071 88.8723 76.0891 88.6701 75.7323 88.5894L45.2205 81.3673C44.9816 81.3026 44.7308 81.2951 44.4885 81.3453C44.2461 81.3955 44.0189 81.5021 43.825 81.6565C43.6312 81.8109 43.4761 82.0088 43.3723 82.2342C43.2686 82.4597 43.219 82.7064 43.2275 82.9546V99.7004C43.2193 100.069 43.3396 100.43 43.5677 100.72C43.7958 101.009 44.1173 101.21 44.4771 101.288Z",
    fill: "url(#paint48_linear_47_2189)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2289 87.6854V99.7011C43.2207 100.07 43.341 100.431 43.5691 100.72C43.7972 101.01 44.1187 101.211 44.4785 101.288L74.9903 108.526C75.2282 108.588 75.4771 108.593 75.7174 108.542C75.9577 108.49 76.1827 108.383 76.3746 108.229C76.5665 108.075 76.72 107.878 76.8229 107.654C76.9258 107.43 76.9753 107.186 76.9675 106.939V95.6536L43.2289 87.6854Z",
    fill: "url(#paint49_linear_47_2189)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7335 88.5896L60.2324 84.923V105.05L74.9901 108.558C75.228 108.619 75.4769 108.625 75.7172 108.573C75.9575 108.521 76.1825 108.414 76.3744 108.26C76.5663 108.106 76.7198 107.909 76.8227 107.686C76.9256 107.462 76.9751 107.217 76.9673 106.97V90.1769C76.9762 89.8099 76.8581 89.4512 76.6332 89.1618C76.4083 88.8724 76.0903 88.6702 75.7335 88.5896Z",
    fill: "url(#paint50_linear_47_2189)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M124.861 104.462C124.86 104.687 124.909 104.909 125.006 105.111C125.103 105.313 125.244 105.491 125.42 105.63C125.595 105.769 125.8 105.867 126.018 105.915C126.237 105.963 126.463 105.96 126.68 105.907L148.587 100.748C148.911 100.67 149.199 100.485 149.406 100.223C149.612 99.9614 149.725 99.6376 149.726 99.3037C149.727 99.0789 149.678 98.8568 149.581 98.6541C149.484 98.4513 149.343 98.273 149.168 98.1326C148.993 97.9922 148.789 97.8933 148.571 97.8432C148.352 97.7931 148.126 97.7932 147.907 97.8434L126.016 103.034C125.691 103.106 125.4 103.286 125.19 103.546C124.98 103.805 124.864 104.128 124.861 104.462Z",
    fill: "url(#paint51_linear_47_2189)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M126.696 111.748L137.61 109.161C137.934 109.083 138.222 108.898 138.428 108.636C138.635 108.374 138.748 108.05 138.749 107.717C138.748 107.493 138.696 107.273 138.598 107.072C138.501 106.871 138.359 106.695 138.185 106.556C138.01 106.418 137.807 106.32 137.59 106.271C137.372 106.222 137.147 106.222 136.93 106.272L126.016 108.859C125.69 108.934 125.398 109.118 125.188 109.38C124.979 109.642 124.864 109.968 124.861 110.304C124.876 110.525 124.937 110.74 125.039 110.936C125.142 111.132 125.284 111.304 125.457 111.441C125.629 111.579 125.829 111.679 126.042 111.734C126.256 111.79 126.479 111.8 126.696 111.764V111.748Z",
    fill: "url(#paint52_linear_47_2189)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_2189",
    x1: 9.63281,
    y1: 93.8431,
    x2: 143.639,
    y2: 200.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_2189",
    x1: 68.0297,
    y1: 121.621,
    x2: 77.3936,
    y2: 121.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_2189",
    x1: 129.449,
    y1: 153.35,
    x2: 155.453,
    y2: 153.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47_2189",
    x1: 32.5519,
    y1: 139.271,
    x2: 87.5592,
    y2: 207.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_47_2189",
    x1: 52.4344,
    y1: 140.906,
    x2: 78.0073,
    y2: 109.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_47_2189",
    x1: 36.6644,
    y1: 186.873,
    x2: 33.3999,
    y2: 203.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_47_2189",
    x1: 116.668,
    y1: 186.873,
    x2: 119.933,
    y2: 203.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_47_2189",
    x1: 76.1581,
    y1: 95.3204,
    x2: 78.1969,
    y2: 122.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_47_2189",
    x1: 53.367,
    y1: 96.7177,
    x2: 54.8637,
    y2: 102.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_47_2189",
    x1: 63.2222,
    y1: 90.5096,
    x2: 73.8356,
    y2: 116.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_47_2189",
    x1: 45.7903,
    y1: 106.208,
    x2: 45.7903,
    y2: 112.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_47_2189",
    x1: 37.5964,
    y1: 122.7,
    x2: 41.6931,
    y2: 122.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_47_2189",
    x1: 33.802,
    y1: 131.494,
    x2: 32.9898,
    y2: 136.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_47_2189",
    x1: 14.3145,
    y1: 161.859,
    x2: 33.2358,
    y2: 194.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_47_2189",
    x1: 23.8205,
    y1: 181.953,
    x2: 22.3715,
    y2: 188.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_47_2189",
    x1: 36.0472,
    y1: 180.414,
    x2: 40.9348,
    y2: 180.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_47_2189",
    x1: 95.3336,
    y1: 173.651,
    x2: 105.307,
    y2: 193.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_47_2189",
    x1: 88.105,
    y1: 177.24,
    x2: 98.0783,
    y2: 197.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_47_2189",
    x1: 86.2987,
    y1: 111.986,
    x2: 220.305,
    y2: 219.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_47_2189",
    x1: 206.133,
    y1: 171.493,
    x2: 232.121,
    y2: 171.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_47_2189",
    x1: 109.22,
    y1: 157.414,
    x2: 164.243,
    y2: 225.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_47_2189",
    x1: 117.571,
    y1: 180.668,
    x2: 104.034,
    y2: 91.4925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_47_2189",
    x1: 113.332,
    y1: 205.017,
    x2: 110.068,
    y2: 221.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_47_2189",
    x1: 193.334,
    y1: 205.017,
    x2: 196.599,
    y2: 221.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_47_2189",
    x1: 152.828,
    y1: 113.461,
    x2: 154.867,
    y2: 140.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_47_2189",
    x1: 159.028,
    y1: 137.588,
    x2: 151.945,
    y2: 116.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_47_2189",
    x1: 130.035,
    y1: 114.858,
    x2: 131.532,
    y2: 121.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_47_2189",
    x1: 139.888,
    y1: 108.653,
    x2: 150.518,
    y2: 134.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_47_2189",
    x1: 151.452,
    y1: 127.018,
    x2: 149.302,
    y2: 117.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_47_2189",
    x1: 122.458,
    y1: 124.351,
    x2: 122.458,
    y2: 130.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_47_2189",
    x1: 114.28,
    y1: 140.843,
    x2: 118.377,
    y2: 140.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_47_2189",
    x1: 110.468,
    y1: 149.636,
    x2: 109.655,
    y2: 154.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_47_2189",
    x1: 90.9964,
    y1: 180.001,
    x2: 109.918,
    y2: 212.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_47_2189",
    x1: 100.486,
    y1: 200.096,
    x2: 99.0374,
    y2: 206.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_47_2189",
    x1: 112.713,
    y1: 198.557,
    x2: 117.616,
    y2: 198.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_47_2189",
    x1: 172.013,
    y1: 191.795,
    x2: 181.987,
    y2: 211.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_47_2189",
    x1: 164.785,
    y1: 195.381,
    x2: 174.758,
    y2: 215.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_47_2189",
    x1: 45.7106,
    y1: 10.1621,
    x2: 179.733,
    y2: 117.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_47_2189",
    x1: 165.545,
    y1: 69.669,
    x2: 191.533,
    y2: 69.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_47_2189",
    x1: 68.6317,
    y1: 55.5899,
    x2: 123.655,
    y2: 123.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_47_2189",
    x1: 72.7443,
    y1: 103.193,
    x2: 69.4798,
    y2: 120.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_47_2189",
    x1: 152.749,
    y1: 103.193,
    x2: 156.03,
    y2: 120.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_47_2189",
    x1: 112.238,
    y1: 11.6385,
    x2: 114.277,
    y2: 38.7799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_47_2189",
    x1: 89.4608,
    y1: 13.0353,
    x2: 90.9575,
    y2: 19.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_47_2189",
    x1: 99.3162,
    y1: 6.82995,
    x2: 109.93,
    y2: 32.5971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_47_2189",
    x1: 81.8693,
    y1: 22.5269,
    x2: 81.8693,
    y2: 28.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_47_2189",
    x1: 73.6921,
    y1: 39.0196,
    x2: 77.7888,
    y2: 39.0196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_47_2189",
    x1: 69.8959,
    y1: 47.813,
    x2: 69.0678,
    y2: 52.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_47_2189",
    x1: 50.4086,
    y1: 78.1928,
    x2: 69.3298,
    y2: 110.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_47_2189",
    x1: 59.9005,
    y1: 98.2726,
    x2: 58.4674,
    y2: 104.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_47_2189",
    x1: 72.1271,
    y1: 96.7482,
    x2: 77.0305,
    y2: 96.7482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_47_2189",
    x1: 131.426,
    y1: 89.9705,
    x2: 141.399,
    y2: 110.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_47_2189",
    x1: 124.197,
    y1: 93.5739,
    x2: 134.17,
    y2: 113.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1);
export default __webpack_public_path__ + "static/media/w1.78e10d33de41edd8fabf1ace88f9c109.svg";
export { ForwardRef as ReactComponent };